module.exports = __webpack_public_path__ + "img/beverages.caaf7e11.png";